/* eslint-disable indent */
/* eslint-disable */

import React from 'react';
import './style.scss'

const Modal = ({ title, message, onClose }) => (
  <div className="warning_modal">
    <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-xl font-semibold mb-4 text-center">{title}</h2>
      <p className="mb-6 text-center">{message}</p>
      <div className="flex justify-center items-center h-full">
        <button style={{marginLeft:"700px"}}
          onClick={onClose}
          className="bg-blue-600 hover:bg-blue-700 text-black px-5 py-2 rounded transition duration-200"
        >
          Close
        </button>
      </div>
    </div>
  </div>
);

export default Modal;
